import React from 'react'
import { Table, Anchor, Badge, Menu, ActionIcon, Paper, Image, Box, Text } from '@mantine/core'
import { IconDotsVertical, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'
import NoImage from '../../../assets/img/images/no-images.png'
import { useNavigate } from 'react-router-dom'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={130} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableNotification = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {

    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }

    return (
      <Table.Tr key={index}>
        <Table.Td>{val.title || '-'}</Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={82} withBorder radius='md' style={{ cursor: 'pointer' }}>
            <Image w={80} h={80} radius='md' src={val.image !== null ? val.image : NoImage} />
          </Paper>
        </Table.Td>
        <Table.Td>{val.notes || '-'}</Table.Td>
        <Table.Td><Badge color="green" tt='capitalize' w={80} fz={11} fw='500'>{val.label}</Badge></Table.Td>
        <Table.Td>{dayjs(val.created_at).format('DD MMMM YYYY')}</Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.recipient !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.recipient)}>{val.recipient !== null ? val.sender.name : 'Created By System'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.recipient !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.recipient)}>{val.recipient !== null ? val.recipient.name : '-'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableNotification